(function() {
  var section = document.querySelector('.reviews--carousel');
  if (!section) return;

  var carousel = section.querySelector('[data-reviews-carousel]');
  var prevBtn = section.querySelector('[data-reviews-prev]');
  var nextBtn = section.querySelector('[data-reviews-next]');
  var itemsPerView = parseInt(carousel.dataset.items) || 4;

  // Wait for jQuery and Owl Carousel to load
  function initCarousel() {
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.owlCarousel === 'undefined') {
      setTimeout(initCarousel, 100);
      return;
    }

    var $carousel = jQuery(carousel);

    $carousel.owlCarousel({
      items: itemsPerView,
      loop: true,
      margin: 24,
      nav: false,
      dots: false,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayHoverPause: true,
      smartSpeed: 500,
      mouseDrag: true,
      touchDrag: true,
      pullDrag: true,
      responsive: {
        0: {
          items: 1,
          margin: 16,
          stagePadding: 20
        },
        576: {
          items: 2,
          margin: 16
        },
        992: {
          items: 3,
          margin: 20
        },
        1200: {
          items: itemsPerView,
          margin: 24
        }
      }
    });

    // Custom nav buttons
    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        $carousel.trigger('prev.owl.carousel');
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        $carousel.trigger('next.owl.carousel');
      });
    }
  }

  initCarousel();
})();

/* Disable spellcheck in Judge.me review textarea */
document.addEventListener("click", function () {
  setTimeout(function () {
    const textarea = document.querySelector(".jdgm-rev__body-input");
    if (textarea) {
      textarea.setAttribute("spellcheck", "false");
    }
  }, 500);
});